<script>
import moment from 'moment';
// eslint-disable-next-line no-unused-vars
import {ValidateUtil} from '@/plugins/app-util.js';
import {inject} from 'vue';
import DesignDropdownSelect from '@/components/design-system/design-dropdown-select.vue';
import { contractType } from '@/assets/data/optionData.js';
import designDialogueModal from '@/components/design-system/design-dialogue-modal.vue';
import designButton from '@/components/design-system/design-button.vue';
import DesignInput from '@/components/design-system/design-input.vue';
import DesignAmountInput from '@/components/design-system/design-amount-input.vue';

export default {
    props: {
        modelValue: Boolean,
        name: String,
    },
    emits: ['closePopup', 'successInvite', 'update:modelValue', 'closeEdit', 'confirmLeave'],
    components: {
        DesignDropdownSelect,designButton,designDialogueModal, DesignInput, DesignAmountInput
    },
    data() {
        return {
            showErrorNotice: false,
            isEdit: false,
            notificationErrMSG: null,
            mainWorkSchedule: null,
            phoneNumberPrepend: '+63',
            joinDateMinimumDate: moment('1951-01-01').toDate(),
            joinDateMaximumDate: moment('2100-01-01').toDate(),
            departmentOptions: [],
            jobTitleOptions: [],
            workScheduleOptions: [],
            workPlaceOptions: [],
            employmentTypeOptions: contractType,
            salaryAmountTypeOptions: [
                {text: 'Annually', value: 'ANNUALLY'},
                {text: 'Monthly', value: 'MONTHLY'},
                {text: 'Weekly', value: 'WEEKLY'},
                {text: 'Daily', value: 'DAILY'},
                {text: 'Hourly', value: 'HOURLY'},
            ],
            taxCodeOptions: [
                {text: 'S', value: 'S'},
                {text: 'S1', value: 'S1'},
                {text: 'S2', value: 'S2'},
                {text: 'S3', value: 'S3'},
                {text: 'S4', value: 'S4'},
                {text: 'M', value: 'M'},
                {text: 'M1', value: 'M1'},
                {text: 'M2', value: 'M2'},
                {text: 'M3', value: 'M3'},
                {text: 'M4', value: 'M4'},
                {text: 'Z', value: 'Z'},
            ],
            requestErrorMsg: {
                firstName: "First Name can't be blank.",
                lastName: "Last Name can't be blank.",
                phoneNumber: 'Please enter a valid 10-digit mobile number.',
                inviteEmail: 'Please enter a valid email address.',
                employeeId: 'This Employee Employee ID No. is already exist.',
                duplicatedEmail: 'This email address already exists.',
                joinDate: "Join Date can't be blank.",
                workScheduleSeq: 'WorkSchedule is should be selected.',
                salaryAmountType: 'Please select the Payment Type.',
                salaryAmount: 'Please enter the Basic Salary Amount.',
                taxCode: 'Please select the Tax Code.',
                pic: "PIC can’t be blank.",
                tinNo: 'Only numbers are allowed, and please input it in a 12-digit format.',
                sssNo: 'Only numbers are allowed, and please input it in a 10-digit format.',
                pagIbig: 'Only numbers are allowed, and please input it in a 12-digit format.',
                philhealth: 'Only numbers are allowed, and please input it in a 12-digit format.',
                rdoCode: 'Please enter a number in a 4-digit format.',
            },
            requestError: {
                firstName: null,
                lastName: null,
                phoneNumber: null,
                inviteEmail: null,
                employeeId: null,
                joinDate: null,
                workScheduleSeq: null,
                salaryAmountType: null,
                salaryAmount: null,
                taxCode: null,
                tinNo: null,
                pic: null,
                sssNo: null,
                pagIbig: null,
                philhealth: null,
                rdoCode: null,
            },
            request: {
                employeeInviteSeq: null,
                firstName: null,
                middleName: null,
                lastName: null,
                phoneNumber: null,
                inviteEmail: null,
                employeeId: null,
                joinDate: moment().format('YYYYMMDD'),
                employmentType: null,
                workPlaceSeq: null,
                departmentSeq: null,
                jobTitleSeq: null,
                workScheduleSeq: null,
                salaryAmountType: null,
                salaryAmount: null,
                taxCode: null,
                pic: null,
                tinNo: null,
                socialSecuritySystem: null,
                pagIbig: null,
                philhealth: null,
                rdoCode: null,
                bankName: null,
                bankAccountNumber: null,
            },
            initialItem : null,
            formattedTin: '',
            formattedSSS: '',
            formattedPhilhealth: '',
            formattedPagIbig: '',

            showLeaveWithoutSaving : false,
        }; //return
    }, //data
    setup() {
        const {checkSubscription} = inject('appUtil');
        return {checkSubscription};
    },
    computed: {
        isFlexbenOnly() {
            return this.$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE');
        }
    },
    mounted() {
        const self = this;
        self.getInitData();
    },
    methods: {
        isValidCheck() {
            const self = this;
            let isValid = true;

            if (!ValidateUtil.checkIsEmail(self.request.inviteEmail)) {
                self.requestError.inviteEmail = self.requestErrorMsg.inviteEmail;
                isValid = false;
            }

            if (ValidateUtil.invalidPhoneNumber(self.request.phoneNumber) || !ValidateUtil.checkIsNumber(self.request.phoneNumber)) {
                self.requestError.phoneNumber = self.requestErrorMsg.phoneNumber;
                isValid = false;
            }

            if (ValidateUtil.checkIsEmpty(self.request.firstName)) {
                self.requestError.firstName = self.requestErrorMsg.firstName;
                isValid = false;
            }

            if (ValidateUtil.checkIsEmpty(self.request.lastName)) {
                self.requestError.lastName = self.requestErrorMsg.lastName;
                isValid = false;
            }

            if (ValidateUtil.checkIsEmpty(self.request.joinDate)) {
                self.requestError.joinDate = self.requestErrorMsg.joinDate;
                isValid = false;
            }

            // flexben only 일 경우 여기서 검증 종료
            if (self.checkSubscription('FLEXBEN_ONLY_USAGE')) {
                return isValid;
            }

            if (!self.request.workScheduleSeq) {
                self.requestError.workScheduleSeq = self.requestErrorMsg.workScheduleSeq;
                isValid = false;
            }

            if (ValidateUtil.checkIsEmpty(self.request.salaryAmountType)) {
                self.requestError.salaryAmountType = self.requestErrorMsg.salaryAmountType;
                isValid = false;
            }

            if (self.request.salaryAmount == null || !ValidateUtil.checkIsNumber(self.request.salaryAmount)
                || self.request.salaryAmount==0) {
                self.requestError.salaryAmount = self.requestErrorMsg.salaryAmount;
                isValid = false;
            }

            if (ValidateUtil.checkIsEmpty(self.request.taxCode)) {
                self.requestError.taxCode = self.requestErrorMsg.taxCode;
                isValid = false;
            }

            if (ValidateUtil.checkIsEmpty(self.request.pic)) {
                self.requestError.pic = self.requestErrorMsg.pic;
                isValid = false;
            }

            if (self.request.tinNo) {
                const tinNo = self.request.tinNo.replaceAll('-', '');
                if (!ValidateUtil.checkIsNumber(tinNo) || tinNo.length > 14) {
                    self.requestError.tinNo = self.requestErrorMsg.tinNo;
                    isValid = false;
                }
            }
            if (self.request.socialSecuritySystem) {
                const sssNo = self.request.socialSecuritySystem.replaceAll('-', '');
                if (!ValidateUtil.checkIsNumber(sssNo) || sssNo.length != 10) {
                    self.requestError.socialSecuritySystem = self.requestErrorMsg.socialSecuritySystem;
                    isValid = false;
                }
            }
            if (self.request.pagIbig) {
                const pagIbig = self.request.pagIbig.replaceAll('-', '');
                if (!ValidateUtil.checkIsNumber(pagIbig) || pagIbig.length != 12) {
                    self.requestError.pagIbig = self.requestErrorMsg.pagIbig;
                    isValid = false;
                }
            }
            if (self.request.philhealth) {
                const philhealth = self.request.philhealth.replaceAll('-', '');
                if (!ValidateUtil.checkIsNumber(philhealth) || philhealth.length != 12) {
                    self.requestError.philhealth = self.requestErrorMsg.philhealth;
                    isValid = false;
                }
            }
            if (self.request.rdoCode) {
                if (self.request.rdoCode.length > 4) {
                    self.requestError.rdoCode = self.requestErrorMsg.rdoCode;
                    isValid = false;
                }
            }
            return isValid;
        },
        resetErrorMsg() {
            const self = this;
            self.requestError = {
                firstName: null,
                lastName: null,
                phoneNumber: null,
                inviteEmail: null,
                employeeId: null,
                joinDate: null,
                workScheduleSeq: null,
                salaryAmountType: null,
                salaryAmount: null,
                taxCode: null,
                tinNo: null,
                pic: null,
                sssNo: null,
                pagIbig: null,
                philhealth: null,
                rdoCode: null,
            };
        },
        resetRequestData() {
            const self = this;
            self.request = {
                employeeInviteSeq: null,
                firstName: null,
                middleName: null,
                lastName: null,
                phoneNumber: null,
                inviteEmail: null,
                employeeId: null,
                joinDate: moment().format('YYYYMMDD'),
                employmentType: null,
                workPlaceSeq: null,
                departmentSeq: null,
                jobTitleSeq: null,
                workScheduleSeq: null,
                salaryAmountType: null,
                salaryAmount: null,
                taxCode: null,
                tinNo: null,
                socialSecuritySystem: null,
                pagIbig: null,
                philhealth: null,
                rdoCode: null,
                bankName: null,
                bankAccountNumber: null,
                pic: sessionStorage.getItem("pic")
            };
            self.request.workScheduleSeq = self.mainWorkSchedule;
            self.formattedTin = '';
            self.formattedSSS = '';
            self.formattedPhilhealth = '';
            self.formattedPagIbig = '';
        },
        getDepartmentOptions() {
            const self = this;

            const url = self.$api('uri', 'get-department');
            const json_query = JSON.stringify({
                showRootNode: true,
                menuAccessLevelCode: 'TEAM_ACCESS_LEVEL',
            });

            self.$axios.get(url, {params: {json_query}}).then((res) => {
                self.departmentOptions = res.data.data.list.map((dep) => ({
                    text: dep.departmentName,
                    value: dep.departmentSeq,
                }));
            });
        },
        getJobTitleOptions() {
            const self = this;

            const json_query = JSON.stringify({
                limit: -1,
                offset: 0,
            });

            let url = self.$api('uri', 'get-jobTitle');
            self.$axios
                .get(url, {params: {json_query}})
                .then((res) => {
                    self.jobTitleOptions = res.data.data.list.map((item) => ({
                        text: item.jobTitleName,
                        value: item.jobTitleSeq
                    }));
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getWorkPlaceOptions() {
            const self = this;
            const url = self.$api('uri', 'get-work-place');
            self.$axios
                .get(url)
                .then((res) => {
                    return res.data.data.list;
                })
                .then((workPlaceList) => {
                    self.workPlaceOptions = workPlaceList.map((place) => {
                        return {text: place.workPlaceName, value: place.workPlaceSeq};
                    });
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        getWorkScheduleOptions() {
            const self = this;

            const url = self.$api('uri', 'get-workSchedule');
            self.$axios
                .get(url)
                .then((res) => {
                    self.workScheduleOptions = res.data.data.list.map((schedule) => {
                        if (schedule.mainWorkScheduleYn == 'Y') {
                            self.mainWorkSchedule = schedule.workScheduleSeq;
                        }
                        return {
                            text: schedule.workScheduleName,
                            value: schedule.workScheduleSeq,
                        };
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getInitData() {
            const self = this;
            self.getDepartmentOptions();
            self.getJobTitleOptions();
            self.getWorkPlaceOptions();
            self.getWorkScheduleOptions();
            self.request.pic = sessionStorage.getItem("pic");
        },
        updateData(item) {
            const self = this;
            self.isEdit = true;
            const url = self.$api('uri', 'get-invite');
            self.$axios.get(`${url}/${encodeURIComponent(item.employeeInviteSeq)}`).then((res) => {
                self.request = {...res.data.data};
                // self.request.phoneNumber = ValidateUtil.convertPhoneGlobalToLocal( res.data.data.phoneNumber );
                self.request.workScheduleSeq = self.request.workScheduleSeq || self.mainWorkSchedule;

                self.changeTinNumberFormat(self.request.tinNo);
                self.changeSSSNumberFormat(self.request.socialSecuritySystem);
                self.changePhilhealthFormat(self.request.philhealth);
                self.changePagIbigFormat(self.request.pagIbig);
                self.initialItem = JSON.parse(self.orderSafeJsonStringify(self.request));
            });
        },
        getDataForSave() {
            const self = this;

            let {
                firstName,
                middleName,
                lastName,
                phoneNumber,
                employeeId,
                inviteEmail,
                joinDate,
                employmentType,
                departmentSeq,
                jobTitleSeq,
                workScheduleSeq,
                workPlaceSeq,
                salaryAmountType,
                salaryAmount,
                taxCode,
                pic,
                tinNo,
                socialSecuritySystem,
                pagIbig,
                philhealth,
                rdoCode,
                bankName,
                bankAccountNumber,
            } = self.request;

            phoneNumber = ValidateUtil.removeCountryCodePhoneNumber(phoneNumber);
            const employeeName = ValidateUtil.employeeNameSave(firstName, middleName, lastName);
            const saveItem = {
                employeeName,
                firstName,
                middleName,
                lastName,
                phoneNumber,
                joinDate,
                employmentType,
                inviteEmail,
                employeeId,
                departmentSeq,
                jobTitleSeq,
                workScheduleSeq,
                workPlaceSeq,
                salaryAmountType,
                salaryAmount,
                taxCode,
                pic,
                tinNo,
                socialSecuritySystem,
                pagIbig,
                philhealth,
                rdoCode,
                bankName,
                bankAccountNumber,
            };

            for (let key in saveItem) {
                if (!saveItem[key]) continue;
                if (typeof saveItem[key].trim === 'function') {
                    saveItem[key] = saveItem[key].trim();
                }
            }

            return saveItem;
        },
        inviteEmployee() {
            const self = this;
            self.resetErrorMsg();

            if (!self.isValidCheck()) {
                // self.showErrorNotice = true;
                // self.notificationErrMSG = 'Please check the error message';
                return;
            }
            const saveItem = self.getDataForSave();
            const url = self.$api('uri', 'post-invite');
            self.$axios
                .post(url, saveItem)
                .then((res) => {
                    console.log('post res => ', res.data);
                    self.$emit('successInvite', 'It is successfully invited ');
                    self.$emit('closePopup');
                })
                .catch((err) => {
                    if (err.response.data.code == 'HR_INVITE_INSERT_ALREADY_USED_EMAIL_400_FAILED') {
                        self.requestError.inviteEmail = self.requestErrorMsg.duplicatedEmail;
                    } else if (err.response.data.code == 'HR_EMPLOYEE_UPDATE_500_FAILED_DUPLICATED_EMPLOYEE_ID') {
                        alert("Entered Employee ID No. is duplicated. Please enter other Employee ID No.");
                    }
                });
        },
        editInviteEmployee(){
            const self = this;
            self.resetErrorMsg();
            if (!self.isValidCheck()) {
                // self.showErrorNotice = true;
                return;
            }

            const saveItem = self.getDataForSave();
            const url = self.$api('uri', 'put-invite');
            self.$axios
                .put(`${url}/${encodeURIComponent(self.request.employeeInviteSeq)}`, saveItem)
                .then((res) => {
                    self.$emit('closeEdit');
                })
                .catch((err) => {
                    if (err.response.data.code == 'HR_INVITE_INSERT_ALREADY_USED_EMAIL_400_FAILED') {
                        self.requestError.inviteEmail = self.requestErrorMsg.duplicatedEmail;
                    } else if (err.response.data.code == 'HR_EMPLOYEE_UPDATE_500_FAILED_DUPLICATED_EMPLOYEE_ID') {
                        alert("Entered Employee Employee ID No. is duplicated. Please enter other Employee ID No. Number.");
                    }
                });
        },
        changeTinNumberFormat(input) {
            const self = this;
            if (!input) {
                self.formattedTin = "";
                self.request.tinNo = "";
                return;
            }

            const inputValue = input.replace(/\D/g, ''); // Remove non-digit characters
            self.request.tinNo = inputValue;

            let formattedValue = "";
            if (inputValue) {
                formattedValue = inputValue.match(new RegExp('.{1,3}', 'g')).join('-'); // xxx-xxx-xxx
                const regex = /^(\d{3})(\d{3})(\d{3})(\d{1,})$/;
                const match = regex.exec(inputValue);

                if (match) {
                    formattedValue = `${match[1]}-${match[2]}-${match[3]}-${match[4]}`; // xxx-xxx-xxxxx
                }
            }

            self.formattedTin = formattedValue;
        },
        changeSSSNumberFormat(input) {
            const self = this;

            if (!input) {
                self.formattedSSS = "";
                self.request.socialSecuritySystem = "";
                return;
            }

            const inputValue = input?.replace(/\D/g, ''); // Remove non-digit characters
            let formattedValue = '';

            if (inputValue) {
                //
                const patternIndexArr = [2, 7];
                let patternValueArr = [];

                let value = inputValue;
                for (const pIndex of patternIndexArr) {
                    if (value.length > pIndex) {
                        let cut = value.substr(0, pIndex);
                        value = value.substr(pIndex);
                        patternValueArr.push(cut);
                    } else {
                        break;
                    }
                }

                if (value) {
                    patternValueArr.push(value);
                }

                formattedValue = patternValueArr.join('-');

                self.formattedSSS = formattedValue;
            }

            self.request.socialSecuritySystem = inputValue.replace(/\D/g, '');
        },
        changePhilhealthFormat(input) {
            const self = this;

            if (!input) {
                self.formattedPhilhealth = "";
                self.request.philhealth = "";
                return;
            }

            const inputValue = input?.replace(/\D/g, ''); // Remove non-digit characters
            let formattedValue = '';

            if (inputValue) {
                //
                const patternIndexArr = [2, 9];
                let patternValueArr = [];

                let value = inputValue;
                for (const pIndex of patternIndexArr) {
                    if (value.length > pIndex) {
                        let cut = value.substr(0, pIndex);
                        value = value.substr(pIndex);
                        patternValueArr.push(cut);
                    } else {
                        break;
                    }
                }

                if (value) {
                    patternValueArr.push(value);
                }

                formattedValue = patternValueArr.join('-');

                self.formattedPhilhealth = formattedValue;
            }

            self.request.philhealth = inputValue.replace(/\D/g, '');
        },
        changePagIbigFormat(input) {
            const self = this;

            if (!input) {
                self.formattedPagIbig = "";
                self.request.pagIbig = "";
                return;
            }

            const inputValue = input?.replace(/\D/g, ''); // Remove non-digit characters
            let formattedValue = '';

            if (inputValue) {
                //
                const patternIndexArr = [4, 4];
                let patternValueArr = [];

                let value = inputValue;
                for (const pIndex of patternIndexArr) {
                    if (value.length > pIndex) {
                        let cut = value.substr(0, pIndex);
                        value = value.substr(pIndex);
                        patternValueArr.push(cut);
                    } else {
                        break;
                    }
                }

                if (value) {
                    patternValueArr.push(value);
                }

                formattedValue = patternValueArr.join('-');

                self.formattedPagIbig = formattedValue;
            }

            self.request.pagIbig = inputValue.replace(/\D/g, '');
        },
        checkDecimalNumber() {
            const self = this;
            // 0으로 입력된 경우 빈 값으로 정리 (DesignAmountInput은 숫자를 emit)
            if (self.request.salaryAmount == 0) {
                self.request.salaryAmount = null;
            }
        },
        orderSafeJsonStringify(obj) {
            const sorted = Object.keys(obj)
                .sort()
                .reduce((acc, key) => {
                    acc[key] = obj[key];
                    return acc;
                }, {});

            return JSON.stringify(sorted);
        },
        hasUnsavedChanges() {
            const current = this.orderSafeJsonStringify(this.request);
            const initial = this.orderSafeJsonStringify(this.initialItem);
            console.log( {current, initial });
            return current !== initial;
        },
        cancelInvite() {
            const self = this;
            if(self.isEdit && self.hasUnsavedChanges()){
                self.showLeaveWithoutSaving = true;
                return; 
            }

            self.$emit('closePopup');
        },
        leaveWithoutSaving(){
            this.showLeaveWithoutSaving = false;
            this.$emit('closePopup')
        }
    },
};
</script>

<template>
    <div v-show="modelValue" class="z-[80] fixed top-0 w-full h-full bg-black/50 flex justify-center items-center">
        <div class="rounded-3 shadow shadow-modal bg-white overflow-hidden">
            <div class="p-4 flex justify-between items-center border-b-1 border-border-basic-2">
                <h2 class="font-heading-sm-semibold">{{ name }}</h2>
                <a @click="cancelInvite" href="javascript:void(0)">
                    <img src="@/assets/img/app-popup-1.svg" alt="app-popup-1"/>
                </a>
            </div>
            <!--content-->
            <div class="max-h-[70vh] min-w-[640px] overflow-auto">
                <div class="p-6 flex flex-col gap-6">

                    <div class="flex gap-2">
                        <label class="c_label mandatory w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            First Name
                        </label>
                        <DesignInput 
                            v-model="request.firstName"
                            placeholder="Enter First Name"
                            :full="true" :error="requestError.firstName" :maxlength="50"
                            class="w-full"
                        />
                    </div>

                    <div class="flex gap-2">
                        <label class="c_label w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Middle Name
                        </label>
                        <DesignInput 
                            v-model="request.middleName" 
                            placeholder="Enter Middle Name" 
                            class="w-full"
                            :full="true" :maxlength="50"/>
                    </div>

                    <div class="flex gap-2">
                        <label class="c_label mandatory w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Last Name
                        </label>
                        <DesignInput 
                            v-model="request.lastName"
                            placeholder="Enter Last Name"
                            :full="true" :error="requestError.lastName" :maxlength="50"
                            class="w-full"/>
                    </div>

                    <div class="flex gap-2">
                        <label class="c_label mandatory w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Phone Number
                        </label>
                        <div class="flex-1 flex justify-between gap-1">
                            <DesignInput 
                                v-model="phoneNumberPrepend"            
                                class="w-[5rem]" 
                                :disabled="true"
                            />
                            <DesignInput v-model="request.phoneNumber"
                                            placeholder="Enter Phone Number"
                                            :isPhoneNum="true"
                                            :full="true" :error="requestError.phoneNumber"
                                            class="flex-1"/>
                        </div>
                    </div>

                    <div class="flex gap-2">
                        <label class="c_label mandatory w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Work Email
                        </label>
                        <DesignInput v-model="request.inviteEmail" placeholder="Enter Work Email" class="flex-1"
                                        :full="true" :error="requestError.inviteEmail"/>
                    </div>

                    <div class="flex gap-2">
                        <label class="c_label w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Employee ID No.
                        </label>
                        <DesignInput v-model="request.employeeId" placeholder="Enter Employee ID No." class="flex-1"
                                        :full="true" :error="requestError.employeeId"/>
                    </div>

                    <div class="flex gap-2">
                        <label class="c_label mandatory w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Join Date
                        </label>
                        <ElementsDatePicker v-model="request.joinDate" class="flex-1"
                                            :full="true" :error="requestError.joinDate" :minDate="joinDateMinimumDate"
                                            :maxDate="joinDateMaximumDate"/>
                    </div>

                    <div v-if="isFlexbenOnly" class="flex gap-2">
                        <label class="c_label w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Employment Type
                        </label>
                        <DesignDropdownSelect
                            v-model="request.employmentType"
                            :options="employmentTypeOptions"
                            placeholder="Select Office"
                            size="LG"
                            :width="'w-full'"
                            class="flex-1"
                            :full="true" 
                        />
                    </div>

                    <div class="flex gap-2">
                        <label class="c_label w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Office
                        </label>
                        <DesignDropdownSelect
                            v-model="request.workPlaceSeq"
                            :options="workPlaceOptions"
                            placeholder="Select Office"
                            size="LG"
                            :width="'w-full'"
                            class="flex-1"
                            :full="true" 
                        />
                    </div>

                    <div class="flex gap-2">
                        <label class="c_label w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Department
                        </label>
                        <DesignDropdownSelect
                            v-model="request.departmentSeq" placeholder="Select Department"
                            size="LG"
                            :width="'w-full'"
                            class="flex-1"
                            :options="departmentOptions"
                            :useDefaultMsg="true"/>
                    </div>

                    <div class="flex gap-2">
                        <label class="c_label w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Tier
                        </label>
                        <DesignDropdownSelect
                            v-model="request.jobTitleSeq" 
                            placeholder="Select Tier"
                            size="LG"
                            :width="'w-full'"
                            class="flex-1"
                            :options="jobTitleOptions" 
                            :useDefaultMsg="true"/>
                    </div>

                    <div v-if="!$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE')"
                        class="flex gap-2">
                        <label class="c_label w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Work Schedule
                        </label>
                        <DesignDropdownSelect
                            v-model="request.workScheduleSeq"
                            placeholder="Select Work Schedule"
                            size="LG"
                            :width="'w-full'"
                            class="flex-1"
                            :options="workScheduleOptions"
                            :error="requestError.workScheduleSeq"/>
                    </div>

                    <div v-if="!$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE')"
                            class="flex gap-2">
                        <label class="c_label mandatory w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Payment Type
                        </label>
                        <DesignDropdownSelect
                            v-model="request.salaryAmountType"
                            placeholder="Salary Type"
                            size="LG"
                            :width="'w-full'"
                            class="flex-1"
                            :options="salaryAmountTypeOptions"
                            :error="requestError.salaryAmountType"/>
                    </div>

                    <div v-if="!$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE')"
                            class="flex gap-2">
                            <label class="c_label w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                                <p class="w-[5.2rem]">Basic Salary Amount</p> <span class="text-accent-red-3 mb-6">*</span>
                            </label>
                        <DesignAmountInput
                            v-model="request.salaryAmount"
                            :intPartLimit="9"
                            placeholder="Enter Basic Salary Amount"
                            :error="requestError.salaryAmount"
                            @blur="checkDecimalNumber"
                            class="flex-1"
                            lastInnerString="₱"
                        />
                    </div>

                    <div v-if="!$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE')"
                        class="flex gap-2">
                        <label class="c_label mandatory w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Tax Code
                        </label>
                        <DesignDropdownSelect
                            v-model="request.taxCode" placeholder="Select Tax Code"
                            size="LG"
                            :width="'w-full'"
                            class="flex-1"
                            :options="taxCodeOptions" 
                            :error="requestError.taxCode"/>
                    </div>

                    <div v-if="!$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE')"
                        class="flex gap-2">
                        <label class="c_label mandatory w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            PIC
                        </label>
                        <DesignInput
                            v-model="request.pic"
                            class="flex-1"
                            :full="true"
                            :maxlength="50"
                            :error="requestError.pic"
                            :disabled="true"
                        />
                    </div>

                    <div v-if="!$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE')"
                        class="flex gap-2">
                        <label class="c_label w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            TIN
                        </label>
                        <DesignInput
                            v-model="formattedTin"
                            placeholder="000-000-000-00000"
                            class="flex-1"
                            :full="true"
                            :maxlength="17"
                            :error="requestError.tinNo"
                            @input="changeTinNumberFormat($event.target.value)"/>
                    </div>

                    <div v-if="!$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE')"
                        class="flex gap-2">
                        <label class="c_label w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            SSS No.
                        </label>
                        <DesignInput
                            v-model="formattedSSS"
                            placeholder="00-0000000-0"
                            class="flex-1"
                            :full="true"
                            :maxlength="12"
                            :error="requestError.socialSecuritySystem"
                            @input="changeSSSNumberFormat($event.target.value)"/>
                    </div>

                    <div v-if="!$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE')"
                        class="flex gap-2">
                        <label class="c_label w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            PhilHealth No.
                        </label>
                        <DesignInput
                            v-model="formattedPhilhealth"
                            placeholder="00-000000000-0"
                            class="flex-1"
                            :full="true"
                            :maxlength="14"
                            :error="requestError.philhealth"
                            @input="changePhilhealthFormat($event.target.value)"/>
                    </div>

                    <div v-if="!$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE')"
                        class="flex gap-2">
                        <label class="c_label w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            PAG-IBIG No. / HDMF
                        </label>
                        <DesignInput
                            v-model="formattedPagIbig"
                            placeholder="0000-0000-0000"
                            class="flex-1"
                            :full="true"
                            :maxlength="14"
                            :error="requestError.pagIbig"
                            @input="changePagIbigFormat($event.target.value)"/>
                    </div>

                    <div v-if="!$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE')"
                        class="flex gap-2">
                        <label class="c_label w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            RDO Code
                        </label>
                        <DesignInput v-model="request.rdoCode" placeholder="Enter RDO Code" class="flex-1"
                                    :full="true" :maxlength="4" :error="requestError.rdoCode"/>
                    </div>

                    <div v-if="!$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE')"
                        class="flex gap-2">
                        <label class="c_label w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Bank Name
                        </label>
                        <DesignInput v-model="request.bankName" placeholder="Enter Bank Name" class="flex-1"
                                    :full="true" :maxlength="50" :error="requestError.bankName"/>
                    </div>

                    <div v-if="!$appUtil.checkSubscription('FLEXBEN_ONLY_USAGE')"
                        class="flex gap-2">
                        <label class="c_label w-[8rem] h-[2.75rem] flex items-center gap-1 shrink-0">
                            Account Number
                        </label>
                        <DesignInput v-model="request.bankAccountNumber" placeholder="Enter Account Number"
                                    class="flex-1"
                                    :full="true" :maxlength="20" :error="requestError.bankAccountNumber"/>
                    </div>
                </div>

                <div class="sticky bottom-0">
                    <div class="p-4 flex justify-end w-full bg-white gap-2 border-t-1 border-border-basic-2">
                        <designButton
                            class="w-[5rem]"
                            @click-event="cancelInvite"
                            btnText="Cancel" btnSize="MD" btnType="SECONDARY" btnVariant="BORDER" :btnDisabled="false"
                        />
                        <designButton
                            v-if="!isEdit"
                            class="w-[5rem]"
                            @click-event="inviteEmployee"
                            btnText="Invite" btnSize="MD" btnType="PRIMARY" :btnDisabled="false"
                        />
                        <designButton
                            v-else
                            class="w-[5rem]"
                            @click-event="editInviteEmployee"
                            btnText="Save" btnSize="MD" btnType="PRIMARY" :btnDisabled="false"
                        />
                    </div>
                </div>
            </div>
        </div>
        <designDialogueModal 
            v-model="showLeaveWithoutSaving"
            :iconConfig="{label: 'warning', color : 'text-red-400', weight : 'FILL' }"
            :modalTitle="'Leave without saving? \nYour changes will be lost.'"
            :confirmConfig="{label : 'Leave', type : 'RED', action : 'confirm', variant : 'FILL' }"
            :cancelConfig="{ label : 'Cancel', type : 'SECONDARY', action : 'cancel' ,variant : 'BORDER' }"
            @confirm="leaveWithoutSaving"
            @cancel="()=>{showLeaveWithoutSaving = false}"
        />


        <ElementsNotification v-model="showErrorNotice" :notificationMsg="notificationErrMSG" :warning="true"/>
    </div>
</template>
